import { JSONContent } from '@tiptap/core';

import { BORDER_STYLE_NONE } from 'global/constants';
import {
  getRichtextValue,
  isRichtextValueEmpty,
} from '../shared/logic/get-richtext-value';
import { Field } from './response.constants';
import { ResponseBox } from './response-view.style';
import { useResponseRichtextSettings } from './response.hooks';
import { getExtensions } from 'approot/shared/richtext/richtext.utils';
import * as Styled from './response-field-readonly.style';

const ResponseFieldReadonly = ({
  field,
  baseHeight,
  answer,
}: {
  field: Field;
  baseHeight: number;
  answer: JSONContent | null | undefined;
  includeScaffoldInOutput?: boolean;
}) => {
  const settings = useResponseRichtextSettings(field);

  return (
    <ResponseBox variant={BORDER_STYLE_NONE}>
      <Styled.ResponseFieldReadonly
        $baseHeight={baseHeight}
        $baseColour={field.baseColour}
        $numberOflines={field.numberOfLines || 1}
        dangerouslySetInnerHTML={{
          __html: !isRichtextValueEmpty(answer)
            ? getRichtextValue(answer, getExtensions(settings))
            : field.isPlaceholderScaffold && field.placeholder
              ? getRichtextValue(
                  {
                    type: 'doc',
                    content: [
                      {
                        type: 'paragraph',
                        content: [
                          {
                            type: 'text',
                            text: field.placeholder,
                          },
                        ],
                      },
                    ],
                  },
                  getExtensions(settings)
                )
              : '',
        }}
      />
    </ResponseBox>
  );
};

export default ResponseFieldReadonly;
